export default function legacyColorMap(color) {
  switch (color) {
    case 'neutral':
      return 'neutral700';
    case 'lighter':
      return 'neutral500';
    case 'lighter2':
      return 'neutral400';
    case 'accent':
      return 'secondary500';
    case 'accent2':
      return 'secondary700';
    case 'primary':
      return 'primary500';
    case 'secondary':
      return 'secondary500';
    case 'error':
      return 'red500';
    case 'darkGrey':
      return 'neutral700';
    default:
      return color;
  }
}
// This function maps legacy color names to their new equivalents.
// It is used to ensure compatibility with the new color scheme in the Credible design system.
